import template from './was-this-useful-loader.component.html';
var WasThisUsefulLoaderComponentController = /** @class */ (function () {
    function WasThisUsefulLoaderComponentController() {
    }
    WasThisUsefulLoaderComponentController.$inject = [];
    return WasThisUsefulLoaderComponentController;
}());
export var WasThisUsefulLoaderComponent = {
    bindings: {},
    controller: WasThisUsefulLoaderComponentController,
    template: template,
};
